<template>
	<v-card>
		<v-toolbar color="primary" dark>
						Upstate Coin &amp; Gold<br>
						PlatformGold&reg; Terms and Conditions
		</v-toolbar>
		<v-card-text>
			<div class="text-body-2 pt-5">
				Customer (also referred to as <b>“you”</b> and <b>“your”</b> as the context may require) in these PlatformGold&reg; 
				Terms and Conditions (<b>“Terms”</b>) is defined as anyone who transacts business with Upstate Coin &amp;
				Gold (<b>“UCG”</b> and also referred to as <b>“us”</b>, <b>“we”</b>, or <b>“our”</b> as the context may require).
			</div>
			<div class="text-body-2 pt-5">
			<b>THESE TERMS AND CONDITIONS REQUIRE THE USE OF ARBITRATION TO RESOLVE DISPUTES RATHER THAN JURY TRIALS.</b>
			</div>
			<div class="text-body-2 pt-5">
				These Terms are subject to change by UCG without prior written notice at any time, in our sole
				discretion. Any changes to these Terms will be in effect as of the “Last Updated Date” referenced on
				PlatformGold&reg; at: https://platform.gold/#/terms. Customers are expected to review these
				Terms prior to entering into any transactions with UCG so Customers are aware of any changes, as they
				are binding on Customers. Your continued use of PlatformGold® or entering into any transaction
				with UCG after the “Last Updated Date” will constitute your acceptance of and agreement to such changes.
			</div>
			<div class="text-subtitle-1 pt-5">1. Pricing</div>
			<div class="text-body-2 pt-5">
								Pricing in the precious metals industry can be volatile. Changes in commodity prices, supply
				chain, and consumer demand often change regularly. Published prices and rates are to be used
				as indications only and are not offers to buy or sell until they have been confirmed with the
				trading desk or electronically through PlatformGold®. Buy and sell offers over the phone with
				the trading desk are valid for the duration of the phone call only and thereafter withdrawn.
				UCG is not obligated to honor a price on a later phone call but instead will issue a new quote,
				which could be the same as the original or different based on market conditions. Buy and sell
				offers quoted over the phone may differ from offers quoted on PlatformGold®. UCG may, in its
				sole discretion, refuse to enter into any transaction with the Customer.
			</div>
			<div class="text-subtitle-1 pt-5">2. Confirmation of Price, Defaults, and Market Losses</div>
			<div class="text-body-2 pt-5">
				When placing an order or selling to UCG, all transactions are locked in at the time of
				purchase or sale, and your order cannot be canceled once we have issued a confirmation
				number. Payment must be made within 24 hours and received by UCG within five (5) business
				days for purchases made by business check and within two (2)
				business days for purchases made by wire transfer or ACH unless the Customer and the trading desk
				agree to alternative terms.
			</div>
			<div class="text-body-2 pt-5">
				Subject to the provisions relating to the cancellation of Limit Orders, all transactions are
				final; however, if Customer fails to complete the transaction, all orders are subject to our
				market loss policy and an additional $39.50 cancellation fee as described below.
			</div>
			<div class="text-body-2 pt-5">
				All sales must be shipped to the facility address indicated in the Purchase Order within two
				(2) business days unless other terms have been agreed to with the trading desk. If we do not
				receive the items within seven (7) business days, we reserve the right to purchase your items
				at current market value or decline the transaction altogether.
			</div>
			<div class="text-body-2 pt-5">
				When purchasing from or selling to UCG (including upon execution of a Limit Order), you are
				immediately issued a confirmation number that is a binding agreement locking your
				transaction in with our trade desk. This confirms the transaction as well as the prices agreed
				upon by both parties, and it cannot be cancelled once confirmed. If you default on the
				transaction, we reserve the right to recover any losses we incur related to the transaction,
				including, but not limited to, market losses and changes in product premiums, as well as a
				$39.50 cancellation fee to cover the administration costs associated with offsetting the
				original transaction.
			</div>
			<div class="text-body-2 pt-5">
				Market losses related to a Sales Order are calculated by UCG entering an order for the
				Customer to sell the applicable product(s) back to UCG at UCG’s prevailing bid price(s)
				(which include product premiums). Market losses related to a Purchase Order are calculated
				by UCG entering an order for UCG to sell the product(s) back to the Customer at UCG’s
				prevailing ask price(s) (which include product premiums). Customer is responsible for any
				market losses from the time the order is confirmed.
			</div>
			<div class="text-body-2 pt-5">
				You understand and agree that any market gain on cancelled transactions shall remain the
				property of UCG and cannot be used to offset the $39.50 cancellation fee.
			</div>
			<div class="text-body-2 pt-5">
				<b>Payment Options</b>
			</div>
			<div class="text-body-2 pt-5">
				(a) Buying from UCG
			</div>
			<div class="text-body-2 pt-5">
				We accept bank wire transfers, ACH, and business checks as acceptable means of payment
				for online and phone trades.
			</div>
			<div class="text-body-2 pt-5">
				(b) Selling to UCG
			</div>
			<div class="text-body-2 pt-5">
				UCG will pay the Customer via company check (no fee), ACH (no fee), bank wire ($35 fee), or
				overnight checks ($35 fee). Payment fees may be waived from time to time at UCG’s
				discretion. The Customer shall advise UCG of their payment preferences at the time of
				confirmation. UCG will attempt to accommodate changes to payment preferences, but
				changes may not be possible after order confirmation.
			</div>
			<div class="text-body-2 pt-5">
				We also reserve the right to cancel any orders when the confirmed price is incorrect for any
				reason. In addition, we may cancel your order at any time if we do not receive your payments
				in the time frame outlined above.
			</div>
			<div class="text-body-2 pt-5">
				Please be aware when using PlatformGold® whether you are placing a Buy (from UCG) or
				Sell (to UCG) order. You are responsible if you place an order in the wrong direction, and it
				will cost you money if you make this error. All counter-party risk is hedged instantly and
				electronically with our bank when you place an order.
			</div>
			<div class="text-body-2 pt-5">
				If a payment (including a check) tendered by Customer is returned for insufficient funds,
				uncollected funds, or stopped payment, Customer shall pay UCG a $45.00 service fee in
				addition to all other costs and fees (including market losses and cancellation fees) payable to
				UCG.
			</div>
			<div class="text-body-2 pt-5">
				Customer shall reimburse UCG for all costs incurred in collecting any overdue payments and
				related interest (at a rate of eighteen percent (18%) per annum, compounded annually, or the maximum rate permitted by applicable law, whichever is less), including,
				without limitation, attorneys&#39; fees (including in-house attorneys), legal costs, court costs, and
				collection agency fees.
			</div>
			<div class="text-subtitle-1 pt-5">3. Limit Orders</div>
			<div class="text-body-2 pt-5">
				(a) UCG allows certain customers (a <b>"Limit Order Customer"</b>) to place a
				Limit Order to buy products. This enables Limit Order Customers to
				enter a Limit Order to instruct UCG to enter a Sales Order for the
				Limit Order Customer to purchase a product from UCG if UCG’s product
				price reaches a specified amount (<b>"Target Price"</b>). Unless otherwise
				terminated as set forth herein, Limit Orders will expire at the date
				and time specified in the Limit Order. Subject to the other terms
				and conditions set forth below, if the Target Price is triggered the
				Limit Order will be executed, and UCG will endeavor to fulfill the
				Limit Order instructions. A Target Price can be triggered if (1) UCG
				changes our product price for the applicable product on the Limit
				Order to a price that is at or below the Target Price, or (2) UCG
				determines to fill the Limit Order at the Target Price, irrespective
				of the product price. Limit Orders are based on UCG’s product price
				and not prevailing market or spot prices. Except as otherwise set
				forth herein regarding non-fulfillment of Limit Orders, all executed
				Limit Orders will be fulfilled at the Target Price, even if the
				then-current product price is less than the Target Price. There is
				no guaranty that a Target Price will be achieved or that a Limit
				Order will be executed or fulfilled.
			</div>
			<div class="text-body-2 pt-5">
				(b) All Limit Orders are subject to the availability of the
				applicable product at the time the Limit Order is to be fulfilled.
				Products are not reserved at the time the Limit Order is entered or
				pending the fulfillment of a Limit Order and the availability of a
				product at the time the Limit Order is entered does not guaranty
				that the product will be available when the Limit Order is to be
				fulfilled. Unless we elect to partial fill a Limit Order, as set
				forth below, if we do not have sufficient quantities of the
				applicable product available at the time the Limit Order is to be
				fulfilled, the Limit Order will not be executed.
			</div>
			<div class="text-body-2 pt-5">
				(c) A Limit Order will become binding at and from the time that a Limit Order Customer&#39;s
				instructions are received by UCG, whether through PlatformGold® or by phone through the
				trading desk. Once a Limit Order has been executed, a Sales Order will be generated, and the
				Limit Order Customer will be required to comply with the terms and conditions of such Sales
				Order, including the payment terms and UCG&#39;s Market Loss and Cancellation of Orders policies
				as set forth herein.
				Executed limit orders may not be ready for immediate shipment as UCG sometimes pre-sells
				products on order to UCG.
			</div>
			<div class="text-body-2 pt-5">
				(d) Only one product may be purchased per Limit Order.
			</div>
			<div class="text-body-2 pt-5">
				(e) The placing of Limit Orders is entirely at the Limit Order
				Customer’s own risk. UCG accepts no liability for any losses,
				damages, or claims arising from either (i) a Limit Order Customer’s
				failure to cancel a Limit Order if it is no longer applicable and/or
				(ii) a Limit Order Customer making a duplicate instruction. Should
				disputes arise which are caused by either of the matters in (i) and
				(ii) above, UCG bears no responsibility for such matters.
			</div>
			<div class="text-body-2 pt-5">
				(f) Limit Orders can be placed via PlatformGold® at any time of the day. Limit Orders may also
				be placed over the phone through our trading desk during business hours. Once a Limit Order
				Customer has placed a Limit Order, a Limit Order Customer may be able to cancel a Limited
				Order through PlatformGold® if the Limit Order has not been executed and is in &quot;working&quot;
				status. A Limit Order Customer may not cancel a Limit Order after the Limit Order has been
				executed, whether or not we have notified the Limit Order Customer that the Limit Order has
				been executed. When the Limit Order is executed, we will notify the Limit Order Customer and
				the Limit Order Customer will be legally bound by the transaction.
			</div>
			<div class="text-body-2 pt-5">
				(g) Limit Orders may not be fulfilled even if the Target Price is
				triggered in the event:
			</div>
			<ul class="text-body-2 pt-5">
				<li>
					the Limit Order is executed as a result of a sudden market price
					change which reverses prior to our system processing the Limit
					Order;
				</li>
				<li>
					UCG does not have a sufficient inventory of the product available
					to fulfill the Limit Order after the Limit Order is executed
					(including as a result of fulfilling other Limit Orders); and/or
				</li>
				<li>
					UCG determines that the Limit Order was executed as a result of a
					system error.
				</li>
			</ul>
			<div class="text-body-2 pt-5">
				Notwithstanding the foregoing, UCG reserves the right to (1) cancel
				a Limit Order for any reason at any time prior to fulfillment, (2)
				partial fill any Limit Order, and (3) fulfill Limit Orders in any
				order in which UCG determines.
			</div>
			<div class="text-body-2 pt-5">
				(h) It is the Limit Order Customer’s responsibility to ensure that
				Limit Orders remain valid and in line with the Limit Order
				Customer’s current objectives. Limit Order Customers should review
				their current/existing Limit Orders on a regular basis so that they
				are aware of their outstanding commitments.
			</div>
			<div class="text-body-2 pt-5">
				(i) Limit Order Customers should be aware that market conditions
				could cause the price of products to change suddenly and
				dramatically, thereby causing a Limit Order Customer’s Target Price
				to be met at any time.
			</div>
			<div class="text-body-2 pt-5">
				(j) Limit Orders are not assignable or transferrable by Limit Order
				Customers.
			</div>
			<div class="text-subtitle-1 pt-5">4. Taxes & Sales Tax</div>
				Prices are quoted without taxes, tariffs, duties, government import/export fees, etc. The Customer
				is responsible for all taxes, tariffs, duties, and government import/export fees that apply to
				transactions with UCG.  Commercial customers purchasing for resale must have a current resale
				certificate on file for each state where the Customer is conducting business (including states
				where orders are drop-shipped).
			<div class="text-subtitle-1 pt-5">5. Return of Customer Products</div>
			<div class="text-body-2 pt-5">
				UCG reserves the right to return to the Customer products sold and shipped to UCG by the
				Customer (<b>“Customer Products”</b>) that do not meet the requirements and specifications of a
				trade, without liability on the part of UCG. Any return of the Customer Products to Customer
				will be considered a cancellation of the order and subject to UCG’s Market Loss Policy and
				Default provisions, as set forth above. In addition, Customer will be liable for shipping 
				costs to return the Customer Products to Customer.
			</div>
			<div class="text-subtitle-1 pt-5">6. Return Policy</div>
			<div class="text-body-2 pt-5">
				Your satisfaction is important to UCG, so we make returns easy and
				safe. Qualifying orders may be returned for exchange.
				Bullion may not returned. Numismatics may only be returned or
				exchanged if specified during the confirmation, otherwise, there are
				no return privileges. Return Merchandise Authorization (RMA)
				privileges must be requested within 48 hours of receipt. Should you
				wish to liquidate your purchase any time after this period has
				expired, we will buy it back at our prevailing buy price rates.
				Returns must be received at our facility specified in the RMA within seven (7) business
				days after issuing an RMA confirmation. Our receiving department cannot 
				process returned products that are received without an RMA.
				Please contact the UCG trading desk to request an RMA. Please allow 24-72 hours for our
				accounting department to process your return request. Unless otherwise agreed in writing
				by UCG, you are responsible for all shipping charges and the risk of loss for any items
				returned to UCG.
			</div>
			<div class="text-subtitle-1 pt-5">7. Shipping Details</div>
			<div class="text-body-2 pt-5">
				Shipping times seen on the individual product pages are calculated from the time after your
				full payment is processed. Orders are shipped once the entire payment has been fully
				processed. We may ship the entire order in one or multiple boxes on the same or separate
				days. Your order may come from one or more of our facilities. This determination is made by
				our operations department based on your order size, value, product availability, weight, and
				variety. Our supply chain is designed to deliver your product safely and quickly at the lowest
				possible cost. We promise to keep you updated with shipping information throughout the
				process.
			</div>
			<div class="text-body-2 pt-5">
				Please note that executed orders may not be ready for immediate shipment as UCG
sometimes pre-sells products on order to us.
			</div>
			<div class="text-body-2 pt-5">
				All shipments for purchases from UCG are covered under our shipping insurance policy. In
				the unlikely event there is a problem with your shipment during transit, we will work with
				you to ensure you receive the products you ordered. However, we will not accept
				responsibility for any lost, stolen, or damaged packages if 1) you or your customer have left
				instructions with any carriers or delivery service to leave parcels unattended, 2) you or your
				customer have requested to waive the required signature, and/or 3) you or your customer
				have advised any delivery personnel to leave your package with someone else other than
				who is listed on the shipping address, such as a building manager, neighbor, or drop-off
				location.
			</div>
			<div class="text-body-2 pt-5">
				If you believe your package has been lost or stolen, it is extremely important that you contact
				UCG immediately.
			</div>
			<div class="text-body-2 pt-5">
				In the unlikely event that a package containing products you have purchased from UCG has
				not been delivered, we will not be able to refund or reship the purchased product until the
				appropriate carrier has notified us in writing that said package has been declared lost and/or
				stolen. At that point in time, we will, in our sole discretion, either replace the original product
				or refund the full purchase price.
			</div>
			<div class="text-body-2 pt-5">
				You agree to assist with any insurance claim and/or investigation by any law enforcement
				organization in connection with any lost or stolen package. We may not replace the product 
				or refund the purchase price if you fail to assist with any claim or investigation.
			</div>
			<div class="text-subtitle-1 pt-5">8. Set-off; Security Interest and Title</div>
			<div class="text-body-2 pt-5">
				As collateral security for all obligations of Customer to UCG, including the payment of the
				purchase price for any products purchased from UCG and performance in full of all the
				obligations of Customer to UCG, Customer hereby grants UCG a lien on and security interest
				in and to all of the right, title, and interest of Customer in, to, and under all products
				purchased from UCG, wherever located, and whether now existing or hereafter arising or
				acquired from time to time, and in all accessions thereto and replacements or modifications
				thereof, as well as all proceeds (including insurance proceeds) of the foregoing. The security
				interest granted under this provision constitutes a purchase money security interest under
				the applicable Uniform Commercial Code.
			</div>
			<div class="text-body-2 pt-5">
				Customer hereby irrevocably appoints UCG as its attorney-in-fact (which appointment is
				coupled with an interest) and authorizes UCG to file any financing statement, at any time and
				from time to time, which UCG deems appropriate in any relevant jurisdiction with respect to
				the security interests granted herein, as well as any continuation statements and
				amendments thereto, in each case without the signature of Customer where permitted by
				law.
			</div>
			<div class="text-body-2 pt-5">
				Additionally, Customer gives UCG a right of setoff for any amounts owed to UCG or its
				affiliates by Customer or its affiliates against any amounts UCG or its affiliates owes to
				Customer or its affiliates.
			</div>
			<div class="text-body-2 pt-5">
				Title to products sold by UCG to Customer shall remain with UCG and shall not transfer to
				Customer until UCG has been paid in full for such products (including any other fees, costs,
				interest and other amounts to which UCG is entitled from Customer).
			</div>
			<div class="text-subtitle-1 pt-5">9. Limit of Liability</div>
			<div class="text-body-2 pt-5">
				Customer agrees that UCG’s maximum liability for the loss of, or damage to, Customer
				Products shall be no greater than the lesser of (a) the Customer&#39;s declared value insured for
				shipping purposes, and (b) the actual amount the Customer proves was paid for the
				Customer Products. UCG shall not be liable for lost profits, loss of business opportunity,
				damage to reputation, attorneys’ fees, interest, or indirect, incidental, punitive, exemplary,
				special, or consequential losses or damages.
			</div>
			<div class="text-subtitle-1 pt-5">10. Sale or Change of Ownership</div>
			<div class="text-body-2 pt-5">
				Should any of the Customer’s principal information change, it is the Customer&#39;s responsibility to
				update UCG within five (5) business days of such change.
			</div>
			<div class="text-subtitle-1 pt-5">11. Changes to Authorized Persons</div>
			<div class="text-body-2 pt-5">
				The Customer will notify UCG within five (5) business days of any change to the persons
				authorized to trade and/or discuss accounting inquiries for the Customer&#39;s organization. UCG
				shall not be liable to the Customer or any other person or entity for trading by an unauthorized
				person or discussing account information with a person authorized to trade or receive account
				information. The Customer is solely responsible for monitoring its account and trading activity.
				The Customer shall indemnify UCG for all trades made in the Customer&#39;s account, whether by an
				authorized person or an unauthorized person.
			</div>
			<div class="text-subtitle-1 pt-5">12. Account Security and Recording</div>
			<div class="text-body-2 pt-5">
				The Customer and each of its representatives must treat all passwords and usernames provided
				or created by the Customer and/or its representatives as confidential, and the Customer and its
				representatives must not disclose them to any other person or entity. The Customer
				acknowledges that the Customer&#39;s and its representatives&#39; account(s) are personal to them and
				agree not to provide any other person with access to PlatformGold® or portions of it using the
				Customer&#39;s or its representatives&#39; usernames, passwords, or other security information. The
				Customer agrees to notify us immediately of any unauthorized access to or use of the Customer&#39;s
				or its representatives&#39; usernames or passwords or any other breach of security. The Customer
				also agrees to ensure that the Customer and its representatives exit from their accounts at the
				end of each session. The Customer and its representatives should use particular caution when
				accessing their accounts from public or shared computers so that others cannot view or record
				passwords or other personal information.
			</div>
			<div class="text-body-2 pt-5">
				UCG has the right to disable any username, password, or other identifier, whether chosen by you
				or provided by us, at any time in our sole discretion for any or no reason, including if, in our
				opinion, you have violated any provision of these Terms.
			</div>
			<div class="text-body-2 pt-5">
				The Customer consents to UCG&#39;s recording of any telephone conversations with the Customer
				and/or its representatives, without any further notice and without obtaining further consent to
				recordings at future times.
			</div>
			<div class="text-subtitle-1 pt-5">13. Death of a Customer</div>
			<div class="text-body-2 pt-5">
				In the event the Customer dies or becomes incapacitated during an outstanding transaction, UCG
				reserves the sole right to (a) require the authorized agent or estate of the Customer to complete
				the pending transaction; or (b) terminate the transaction and reclaim any money or products
				supplied or sent to the Customer by UCG.
			</div>
			<div class="text-subtitle-1 pt-5">14. Notice of Complaint</div>
			<div class="text-body-2 pt-5">
				Should the Customer have any claim, controversy, or dispute regarding a transaction with UCG,
				the Customer must notify UCG within ten (10) business days. Should the Customer fail to notify
				UCG within this time frame, the Customer shall be prohibited from seeking claims against UCG and
				any loss or damage the Customer might claim.
			</div>
			<div class="text-subtitle-1 pt-5">15. Business Day</div>
			<div class="text-body-2 pt-5">
				We define a business day as any time between Monday and Friday, between 9:00 a.m.
				to 5:00 p.m. Eastern time, excluding United States federal holidays.
			</div>
			<div class="text-subtitle-1 pt-5">16. Illicit Dealings Prohibited</div>
			<div class="text-body-2 pt-5">
				The Customer certifies that they have the legal right to sell the Customer Products to UCG and
				that they have not (a) committed a crime, (b) practiced unethical business, or (c) transacted in an
				illegal trade. The Customer further certifies that the Customer Products are not owed by anyone
				other than the Customer selling the Customer Products, there are no liens or claims on the
				Customer Products, and the Customer has complied with local regulations for secondhand
				purchases, including holding and reporting requirements.
			</div>
			<div class="text-subtitle-1 pt-5">17. Mathematical, Typographical, or Other Errors</div>
			<div class="text-body-2 pt-5">
				Should UCG commit mathematical, typographical, or other errors on quotation or payment, the
				Customer agrees to take all steps requested by UCG to rectify the error(s), and the Customer
				shall not hold UCG liable for any damages arising from such errors.
			</div>
			<div class="text-subtitle-1 pt-5">18. Packaging</div>
			<div class="text-body-2 pt-5">
				UCG assumes no liability for packages we receive in damaged condition or with Customer
				Products missing. It is the responsibility of the Customer to deliver the Customer Products to
				UCG in their completeness.
			</div>
			<div class="text-subtitle-1 pt-5">19. Shipping and Risk of Loss for Customer Products</div>
			<div class="text-body-2 pt-5">
				It is the responsibility of the Customer to pay for the shipping and delivery of Customer Products
				to UCG unless specifically provided an alternative in writing by UCG. The Customer must include
				a packing list stating the contents of the package and must ship to the address provided at the
				time of the transaction. UCG will not be responsible for any damage, loss, or other claims to a
				package shipped by the Customer to an incorrect address or which does not include a packing
				slip. Customer shall be responsible for all of risk of loss with respect to Customer Products until
				such time as UCG completes the purchase of such Customer Products and title to the Customer
				Products has transferred to UCG.
			</div>
			<div class="text-subtitle-1 pt-5">20. Credit Verification &amp; USA Patriot Act Compliance</div>
			<div class="text-body-2 pt-5">
				UCG reserves the right to make criminal, credit, and general background checks about the
				Customer and its agents, principals, and representatives. The Customer, on its behalf and on
				behalf of its agents, principals, and representatives, consents to UCG conducting background
				checks on the Customer and the Customer’s agents, principals, and representatives, and the
				Customer has obtained consent from each of its agents, principals, and representatives for such
				background checks.
			</div>
			<div class="text-subtitle-1 pt-5">21. Risks</div>
			<div class="text-body-2 pt-5">
				The Customer understands that all coin and bullion products and transactions involve risk. The
				value of coins and bullion may be affected by many factors, including, but not limited to, current
				market pricing, perceived scarcity, and current demand. Purchasing and selling coins and bullion
				is not suitable for everyone. Coins and bullion can lose value. By entering into a transaction with
				UCG, the Customer warrants that the Customer has adequate cash reserves and disposable
				income to trade such products and possesses an experience level competent to do so.
			</div>
			<div class="text-subtitle-1 pt-5">22. Document Production</div>
			<div class="text-body-2 pt-5">
				If UCG is required by government regulation, subpoena, or other legal process to produce
				information, records, documents, or personnel as witnesses with respect to the Customer
				and/or any products or services provided by UCG to the Customer, the Customer shall, so
				long as UCG is not a party to the proceeding in which the information is sought, reimburse
				UCG (in advance if requested by UCG) for its professional time (at a rate of $100 per hour
				per person, subject to increase by UCG from time-to-time) and expenses, as well as
				reasonable attorneys&#39; fees (including in-house attorneys) and expenses incurred in
				responding to such requests.
			</div>
			<div class="text-subtitle-1 pt-5">23. Disclaimer of Warranties</div>
			<div class="text-body-2 pt-5">
				No warranties, written or oral, express or implied, shall be binding upon UCG unless written
				herein.
			</div>
			<div class="text-subtitle-1 pt-5">24. Provisions</div>
			<div class="text-body-2 pt-5">
				Each provision of the Terms is independent. Should any provision be ruled wholly or partly
				invalid by a competent court or in arbitration, all other provisions shall remain valid and
				enforceable. In the event of a termination of Customer’s account with UCG, any provision that,
				in order to give proper effect to its intent, should survive the termination of the account will
				survive such termination.
			</div>
			<div class="text-subtitle-1 pt-5">25. Geographic Restrictions</div>
			<div class="text-body-2 pt-5">
				UCG is headquartered in the state of Colorado in the United States. We make no claims that
				PlatformGold® or any of its content is accessible or appropriate outside of the United States.
				Access to PlatformGold® may not be legal by certain persons or in certain countries. If you
				access PlatformGold® from outside the United States, you do so on your own initiative and are
				responsible for compliance with local laws.
			</div>
			<div class="text-subtitle-1 pt-5">26. Force Majeure</div>
			<div class="text-body-2 pt-5">
				UCG shall not be liable for any delay or nonperformance caused, in whole or in part, by the
				occurrence of any contingency beyond the control of UCG, including but not limited to, acts of
				government, terrorism, acts of God, sabotage, shortage of materials, and delay in transportation.
			</div>
			<div class="text-subtitle-1 pt-5">27. Applicable Law</div>
			<div class="text-body-2 pt-5">
				The rights and obligations of UCG and the Customer provided in these terms and conditions shall
				be governed by, construed, and enforced in accordance with the laws of the State of Colorado
				without regard to conflicts of principal law.
				The parties exclude the application to this Agreement of the United Nations Convention on
				Contracts for the International Sale of Goods.
			</div>
			<div class="text-subtitle-1 pt-5">28. Arbitration</div>
			<div class="text-body-2 pt-5">
				The Customer agrees that claims, disputes, or controversies between the Customer and UCG
				from any transaction between Customer and UCG shall be resolved by binding arbitration in the
				state of Colorado in the county of Arapahoe. The arbitration will be resolved in accordance with
				the rules and procedures of the American Arbitration Association for commercial arbitration and
				the Customer waives the right to class arbitration. Any decision rendered in such arbitration is
				binding for all parties. Fees for the arbitrator shall be divided equally between both parties
				regardless of the outcome. Each side shall be responsible for paying their separate attorney&#39;s
				costs and waives the arbitrator&#39;s ability to shift expenses to one side, except in the event
				Customer fails to complete a transaction. If the Customer fails to complete a transaction, the
				Customer will be responsible for UCG&#39;s attorney fees, legal costs, and fees for the arbitrator in
				addition to the default amount. Should the Customer bring actions against UCG other than
				arbitration, the Customer shall be responsible for all legal and other expenses incurred by UCG,
				including, but not limited to, attorneys&#39; fees. Should the Customer fail to abide by the ruling of
				the arbitrator, the Customer is responsible for all legal and other expenses to recover, enforce,
				and defend the award made by the arbitrator.
			</div>
			<div class="text-body-2 pt-5">
				Any decisions regarding the arbitrability of a claim shall be made by an arbitrator pursuant to this
				section. In the event a claim is not subject to arbitration and is not an Excluded Claim (as defined
				below), such claim shall be brought in the state courts located in Arapahoe County, Colorado, or
				the federal courts located in Denver, Colorado.
			</div>
			<div class="text-body-2 pt-5">
				Notwithstanding anything herein to the contrary, claims by UCG against Customer, its
				representatives and/or its principals for the return of products, the failure to complete a
				transaction with UCG, and/or the collection or payment of charges, damages (liquidated or
				otherwise), or any other amounts due or payable to UCG by the Customer, its principals and/or
				representatives under any agreement, including prior agreements, between the parties, are not
				subject to mandatory binding arbitration (collectively <b>&quot;Excluded Claims&quot;</b>) but the Customer and
				UCG may mutually agree to arbitrate such claims. UCG may bring an action related to any
				Excluded Claims in any court in any jurisdiction as determined by UCG.
			</div>
			<div class="text-body-2 pt-5">
				With respect to any Excluded Claims, UCG shall be entitled to receive, in addition to all other
				damages to which it may be entitled, the costs incurred by UCG in conducting the suit, action, or
				proceeding, including actual attorneys&#39; fees and expenses and court costs. With respect to
				Excluded Claims, UCG shall also be entitled to prejudgment and post-judgment interest at a rate
				of eighteen percent (18%) per annum, compounded annually, or the maximum rate permitted by applicable law, whichever is less.
			</div>
			<div class="text-subtitle-1 pt-5">29. PlatformGold Google App</div>
			<div class="text-body-2 pt-5">
				The PlatformGold Google App allows customers to login to PlatformGold and other customer
				applications using the customer’s Google user identity.
			</div>
			<ul class="text-body-2 pt-5">
				<li>
					<b>User Responsibilities:</b> You are responsible for rules governing your service and account
					management, including maintaining the confidentiality of your Google credentials.
				</li>
				<li>
					<b>Termination Clause:</b> UCG reserves the right to suspend or terminate user access if these
					Terms are violated.
				</li>
				<li>
					<b>Compliance:</b> Our use of Google APIs is governed by the Google API Services User Data
					Policy.
				</li>
			</ul>
			<div class="text-caption pt-5">Last Revised Date: February 19, 2026</div>
		</v-card-text>
	</v-card>
</template>

<script>
import Vue from 'vue'
import _ from 'lodash'

export default {
  props: ['buySell', 'limitOrder'],
  data() {
    return {
      dialog: false,
    }
  },
  methods: {
    closeDialog() {
      this.dialog = false
      // Workaround for https://github.com/vuetifyjs/vuetify/issues/5356
      Vue.nextTick().then(function() {
        document.documentElement.classList.add('overflow-y-hidden')
      })
    },
  },
  mounted() {
    window._VMA.$on('SHOW_TERMS', () => {
      this.dialog = true
    })
  },
}
</script>
